"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorsLink = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("components");
var ColorsLink = function () { return (react_1.default.createElement("div", null,
    react_1.default.createElement(components_1.Link, { to: "colors" }, "Colors"),
    react_1.default.createElement("div", { className: "py1 pl4" },
        react_1.default.createElement(components_1.Link, { to: { hash: "background", pathname: "colors" } }, "Background"),
        react_1.default.createElement(components_1.Link, { to: { hash: "border", pathname: "colors" } }, "Border"),
        react_1.default.createElement(components_1.Link, { to: { hash: "text", pathname: "colors" } }, "Text")))); };
exports.ColorsLink = ColorsLink;
